import clx from 'classnames'
import styles from './NoData.css'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'

const NoData = ({ className, description }) => {
  return (
    <div className={clx(styles.NoData, className)}>
      <img src={`${CDN}/supplier/img_searchnodata_1567392001662.svg`} />
      <p>{description}</p>
    </div>
  )
}

export default NoData
